import breakTo from '../../styles/tools/breakTo'

export default ({ colors, fontWeights }) => ({
  'widget-group': {
    [breakTo('medium')]: {
      // overflow: 'hidden',

      marginBottom: '3rem'
    }
  },

  'widget-group__title': {
    color: colors.widget.groupTitle.default,
    [breakTo('medium')]: {
      position: 'absolute',
      marginLeft: '-16vw',
      fontWeight: fontWeights.widget.group,
      marginTop : '2.5vw',
      width: '14vw',
      textAlign: 'right'
    }
  },
  'widget-group__maintitle': {
    color: colors.widget.groupTitle.default,
    [breakTo('medium')]: {
      position: 'absolute',
      marginLeft: '-6.5vw',
      fontWeight: fontWeights.widget.group,
      marginTop : '-1.5vw',
      textAlign: 'right'
    }
  },


  'widget-group__inputs': {
    [breakTo('medium')]: {
      float: 'left',

      width: '100%'
    }
  },

  'widget-group__inputs--invalid': {
    maxWidth: '43rem',

    borderBottom: `2px solid ${colors.common.utility.error.default}`
  },

  'widget-group__error-msg': {
    display: 'block',

    marginTop: '.5rem',

    textAlign: 'center',

    color: colors.common.utility.error.default
  },
  'widget-group__margin-min-bottom':{
    marginBottom : '-1rem !important'
  }
})



// WEBPACK FOOTER //
// ./components/widgets/styles.js